import { render, staticRenderFns } from "./list2Edit.vue?vue&type=template&id=3597e373&scoped=true&"
import script from "./list2Edit.vue?vue&type=script&lang=js&"
export * from "./list2Edit.vue?vue&type=script&lang=js&"
import style0 from "./list2Edit.vue?vue&type=style&index=0&id=3597e373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597e373",
  null
  
)

export default component.exports